import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface PartnerState {
  isPartnerLoggedIn: boolean;

  name: string | null;
  variant: "default" | "lianlian" | string;
  config: Record<string, string>;
}


const initialState: PartnerState = {
  isPartnerLoggedIn: false,
  name: null,
  variant: "default",
  config: {},
};


export const partnerSlice = createSlice({
  name: "partner",
  initialState,
  reducers: {
    partnerLogin(state) {
      state.isPartnerLoggedIn = true;
    },

    setPartnerContext(state, action: PayloadAction<{ name: string; onboarding_variant?: string; onboarding_config?: Record<string, string>; }>) {
      state.isPartnerLoggedIn = true;
      state.name = action.payload.name;
      state.variant = action.payload.onboarding_variant ?? "default";
      state.config = action.payload.onboarding_config ?? {};
    },

    partnerLogout() {
      return initialState;
    },
  },
});

export const { partnerLogin, setPartnerContext, partnerLogout } = partnerSlice.actions;
export default partnerSlice.reducer;


